import {
  Component,
  OnInit,
  OnChanges,
  AfterViewInit,
  ViewChild,
  Input,
  Output,
  EventEmitter
} from "@angular/core";
import { appSettings, errorMessages } from "../../../settings";
import {
  CommonService,
  DashboardService,
  WidgetService
} from "../../../services";
import { UserPreference } from "../../../models/UserPreference";
import { User } from "../../../models/UserObj";
import * as moment from "moment";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { WidgetFieldSetting } from "../../../models/WidgetFieldSetting";
import { WidgetSetting } from "../../../models/WidgetSetting";
import { WidgetCriteria } from "../../../models/DataModels";

@Component({
  selector: "app-widgetsettings",
  templateUrl: "./widgetsettings.component.html",
  styleUrls: ["./widgetsettings.component.scss"]
})
export class WidgetsettingsComponent implements OnInit {
  @Input("widget") widget: any;
  @Input("edit") edit: boolean = false;
  loading: boolean = false;
  errorMessage: string;
  user: User;
  userPreference: UserPreference;
  widgetFieldSetting: WidgetFieldSetting;

  shipmentTypeArray: Array<any> = [];
  orderPriorityArray: Array<any> = [];
  carrierArray: Array<any> = [];
  countryCodeArray: Array<any> = [];
  passThruArray: Array<string> = [
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20"
  ];
  waveTypeArray: Array<any> = [];

  widgetName: string;
  widgetSettingsArray: Array<any>[];
  checkedPast: boolean;
  checkedCurrent: boolean = true;
  checkedFuture: boolean;
  pickType: string = "PostShip";
  varianceType: string = "VARIANCE_BY_LOCATIONS";
  openTasksType: string = "ByWave";
  shiptoCountry: string = "US";
  zbProductivityInput: number = 200;
  zbDesiredHourlyUnits: number = 2000;
  selShipmentType: Array<string>;
  selOrderPriority: Array<string>;
  selCountryCode: Array<string>;
  selCarrier: Array<string>;
  selWave: any;
  selDateRange: any;
  checkedBatchWave: boolean;
  lithium: boolean;
  selPassThru: string;
  commitDate: any = null;
  monitorType: string = "ORDERS";
  storeName: string;
  firstWaveTime: any = {};
  dataPassThru: Array<any> = [{ m_Item1: "", m_Item2: "" }];
  defaultSummaryType: Array<any> = [
    { Name: "Daily", Value: "D", Enabled: true },
    { Name: "Weekly", Value: "W", Enabled: true },
    { Name: "Monthly", Value: "M", Enabled: true },
    { Name: "Quarterly", Value: "Q", Enabled: true },
    { Name: "Yearly", Value: "Y", Enabled: true }
  ];
  selSummaryType: any;
  dateRangeList: Array<any> = [
    {
      name: appSettings.LastWeek
    },
    {
      name: appSettings.Last2Weeks
    },
    {
      name: appSettings.Last1month
    },
    {
      name: appSettings.Last2months
    },
    {
      name: appSettings.Last3months
    },
    {
      name: appSettings.Last6months
    },
    {
      name: appSettings.Last13months
    }
    // ,
    // {
    //   name: appSettings.CustomRange
    // }
  ];

  waveStatusType: Array<any> = ['INDIVIDUAL PUTWALL','INDIVIDUAL PACK PUTWALL'];
  waveStatusActive: Array<any> = ['ACTIVE','INACTIVE'];
  selWaveStatusType: string = 'INDIVIDUAL PUTWALL';
  selWaveStatusActive: string = 'ACTIVE';
  releasedWaveArray: Array<any> = [];
  allPutwallArray: Array<any> = [];
  putwallArray: Array<any> = [];
  selReleasedWave: any;
  selPutwall: any;

  constructor(
    private _commonService: CommonService,
    private _dashboardService: DashboardService,
    private _widgetService: WidgetService,
    public activeModal: NgbActiveModal
  ) { }

  ngOnInit() {
    console.log("widgetsettings", this.widget);
    this.widgetFieldSetting = new WidgetFieldSetting();
    this.defineWidgetForm();
  }

  defineWidgetForm() {
    document.getElementById("editwidgetModalpopup").style.width = "450px";
    switch (this.widget.type) {
      case appSettings.TotalProgression:
        this.widgetFieldSetting.WidgetName = true;
        this.widgetFieldSetting.DaySetting = true;
        break;
      case appSettings.OrderStatus:
        this.widgetFieldSetting.WidgetName = true;
        this.widgetFieldSetting.DaySetting = true;
        this.widgetFieldSetting.PickType = true;
        break;
      case appSettings.PullTimesMonitor:
        this.widgetFieldSetting.WidgetName = true;
        this.widgetFieldSetting.MonitorType = true;
        this.widgetFieldSetting.FirstWaveTime = true;
        document.getElementById("editwidgetModalpopup").style.width = "510px";
        break;
      case appSettings.ProgressTracking:
        this.widgetFieldSetting.WidgetName = true;
        this.widgetFieldSetting.ShipmentType = true;
        this.widgetFieldSetting.OrderPriority = true;
        this.widgetFieldSetting.DaySetting = true;
        this.widgetFieldSetting.PickType = true;
        this.widgetFieldSetting.HasLithirum = true;
        this.widgetFieldSetting.CommitDate = true;
        this.widgetFieldSetting.CountryCode = true;
        this.widgetFieldSetting.Carrier = true;
        this.widgetFieldSetting.PassThru = true;
        document.getElementById("editwidgetModalpopup").style.width = "800px";
        break;
      case appSettings.Waveprogression:
        this.widgetFieldSetting.WidgetName = true;
        this.widgetFieldSetting.BatchWave = true;
        break;
      case appSettings.Storewaveprogression:
        this.widgetFieldSetting.WidgetName = true;
        this.widgetFieldSetting.StoreTitle = true;
        this.widgetFieldSetting.BatchWave = true;
        document.getElementById("editwidgetModalpopup").style.width = "510px";
        break;
      case appSettings.WavePullTimesMonitor:
        this.widgetFieldSetting.WidgetName = true;
        //this.widgetFieldSetting.MonitorType = true;
        //this.widgetFieldSetting.FirstWaveTime = true;
        this.widgetFieldSetting.BatchWave = true;
        document.getElementById("editwidgetModalpopup").style.width = "510px";
        break;
      case appSettings.WaveOrderStatus:
        this.widgetFieldSetting.WidgetName = true;
        this.widgetFieldSetting.WaveType = true;
        this.widgetFieldSetting.BatchWave = true;
        break;
      case appSettings.WaveTrend:
      case appSettings.WavePerformance:
      case appSettings.CurrentInventory:
      case appSettings.ReturnsLocationsAvailability:
        this.widgetFieldSetting.WidgetName = true;
        break;
      case appSettings.InventoryAccuracy:
      case appSettings.OnTimeShipment:
      case appSettings.TransitionalInventory:
      case appSettings.ForceClosedPackwaves:
      case appSettings.ToteRecirculating:
      case appSettings.BlindCountError:
      case appSettings.HospitalPackedOrderSummary:
      case appSettings.MHEMonitoringSummary:
        this.widgetFieldSetting.WidgetName = true;
        this.widgetFieldSetting.DateRange = true;
        break;
      case appSettings.Variance:
        this.widgetFieldSetting.WidgetName = true;
        this.widgetFieldSetting.VarianceType = true;
        break;
      case appSettings.OpenPicksTask:
      case appSettings.OpenReplensTasks:
        this.widgetFieldSetting.WidgetName = true;
        this.widgetFieldSetting.OpenTasksType = true;
        break;
      case appSettings.ShortedOrders:
        this.widgetFieldSetting.WidgetName = true;
        this.widgetFieldSetting.ShiptoCountry = true;
        break;  
      case appSettings.ZoneBalancing:
        this.widgetFieldSetting.WidgetName = true;
        this.widgetFieldSetting.ZoneBalancing = true;
        break; 
      case appSettings.MHENoReadData:
        this.widgetFieldSetting.WidgetName = true;
        this.widgetFieldSetting.DateRange = true;
        this.widgetFieldSetting.SummaryType = true;
        break; 
      case appSettings.WaveOrdStatus:
        this.widgetFieldSetting.WidgetName = true;
        this.widgetFieldSetting.WaveOrderStatusType = true; 
        
        if(this.widget.widgetsettings){
          let criteria = this.widget.widgetsettings.Criteria ? JSON.parse(this.widget.widgetsettings.Criteria) : null;
          if(criteria && criteria.WaveStatusType == 'INDIVIDUAL PACK WAVE'){         
            this.widgetFieldSetting.ReleasedWaveLookup = true; 
          }
        }
        this.waveStatusType = ['ALL WAVES','INDIVIDUAL WAVE','INDIVIDUAL PACK WAVE']; 
        this.selWaveStatusType = 'ALL WAVES';   
        document.getElementById("editwidgetModalpopup").style.width = "700px"; 
          break; 
      case appSettings.PutwallOrderStatus:
        this.widgetFieldSetting.WidgetName = true;
        this.widgetFieldSetting.WaveOrderStatusType = true;
        this.widgetFieldSetting.WaveOrderStatusActive = true; 
        
        if(this.widget.widgetsettings){
          let criteria = this.widget.widgetsettings.Criteria ? JSON.parse(this.widget.widgetsettings.Criteria) : null;
          if(criteria && criteria.WaveStatusType == 'INDIVIDUAL PACK PUTWALL'){         
            this.widgetFieldSetting.PutwallLookup = true;
          }
        }
        this.waveStatusType = ['INDIVIDUAL PUTWALL','INDIVIDUAL PACK PUTWALL']; 
        this.selWaveStatusType = 'INDIVIDUAL PUTWALL'; 
        document.getElementById("editwidgetModalpopup").style.width = "600px"; 
          break; 
      case appSettings.CubbyOrderStatus:
        this.widgetFieldSetting.WidgetName = true;
        this.widgetFieldSetting.WaveOrderStatusType = true; 
        this.widgetFieldSetting.WaveOrderStatusActive = true;  
        this.waveStatusType = ['ALL CUBIES','INDIVIDUAL PUTWALL']; 
        this.selWaveStatusType = 'ALL CUBIES';  
        document.getElementById("editwidgetModalpopup").style.width = "600px";
          break;
    }

    this.loadMasterData();
  }

  loadMasterData() {
    let userPref = this._commonService.getUserPreference();
    if (this.widgetFieldSetting.ShipmentType == true) {
      console.time("getShipmentTypes");
      this._dashboardService
        .getShipmentTypes(userPref.FacilityId, userPref.CustomerId)
        .subscribe(
          data => {
            console.timeEnd("getShipmentTypes");
            //console.log('getShipmentTypes', data)
            this.shipmentTypeArray = data;
          },
          err => {
            console.timeEnd("getShipmentTypes");
            console.log("getShipmentTypes", err);
          }
        );
    }

    if (this.widgetFieldSetting.OrderPriority == true) {
      console.time("getOrderPriorities");
      this._dashboardService
        .getOrderPriorities(userPref.FacilityId, userPref.CustomerId)
        .subscribe(
          data => {
            console.timeEnd("getOrderPriorities");
            //console.log('getOrderPriorities', data)
            this.orderPriorityArray = data;
          },
          err => {
            console.timeEnd("getOrderPriorities");
            console.log("getOrderPriorities", err);
          }
        );
    }

    if (this.widgetFieldSetting.CountryCode == true) {
      console.time("getCountrycodes");
      this._dashboardService
        .getCountrycodes(userPref.FacilityId, userPref.CustomerId)
        .subscribe(
          data => {
            console.timeEnd("getCountrycodes");
            //console.log('getCountrycodes', data)
            this.countryCodeArray = data;
          },
          err => {
            console.timeEnd("getCountrycodes");
            console.log("getCountrycodes", err);
          }
        );
    }

    if (this.widgetFieldSetting.Carrier == true) {
      console.time("getCarriers");
      this._dashboardService
        .getCarriers(userPref.FacilityId, userPref.CustomerId)
        .subscribe(
          data => {
            console.timeEnd("getCarriers");
            //console.log('getCarriers', data)
            this.carrierArray = data;
          },
          err => {
            console.timeEnd("getCarriers");
            console.log("getCarriers", err);
          }
        );
    }

    if (this.widgetFieldSetting.WaveType == true) {
      console.time("getWaves");
      this._dashboardService
        .getWaves(userPref.FacilityId, userPref.CustomerId)
        .subscribe(
          data => {
            console.timeEnd("getWaves");
            //console.log('getCarriers', data)
            let waveTypes: Array<any> = [{ value: "", label: "All Waves" }];
            data.forEach(item => {
              waveTypes.push({
                value: item.Value,
                label: item.Title
              });
            });
            this.waveTypeArray = waveTypes;
            if (!this.selWave) {
              this.selWave = { value: "", label: "All Waves" };
            }
            console.log(this.waveTypeArray);
          },
          err => {
            console.timeEnd("getWaves");
            console.log("getWaves", err);
          }
        );
    }

    if (this.widgetFieldSetting.ReleasedWaveLookup == true) {
        this.getReleasedWaveLookup();
    }

    if (this.widgetFieldSetting.PutwallLookup == true) {
       this.getPutwallLookup();
    }

    //set the existing value
    this.setWidgetData();
  }

  setWidgetData() {
    console.log("setWidgetData");

    let data = this.widget.widgetsettings;
    if (this.widgetFieldSetting) {
      if (this.widgetFieldSetting.WidgetName == true) {
        this.widgetName = data.WidgetName;
      }
      if (this.widgetFieldSetting.DaySetting == true) {
        this.checkedPast = data.IsPast == "Y" ? true : false;
        this.checkedFuture = data.IsFuture == "Y" ? true : false;
        this.checkedCurrent = data.IsCurrent == "Y" ? true : false;
      }
      if (this.widgetFieldSetting.PickType == true) {
        this.pickType = data.PickType;
      }
      if (this.widgetFieldSetting.VarianceType == true) {
        this.varianceType = data.PickType == "PostShip" ? this.varianceType : data.PickType;
      }
      if (this.widgetFieldSetting.OpenTasksType == true) {
        this.openTasksType = data.DaySetting == "PostShip" ? this.openTasksType : data.PickType;
      }
      if (this.widgetFieldSetting.ShiptoCountry == true) {
        this.shiptoCountry = data.PickType == "PostShip" ? this.shiptoCountry : data.PickType;
      }
      if (this.widgetFieldSetting.MonitorType == true) {
        this.monitorType = data.MonitorType;
      }
      if (this.widgetFieldSetting.StoreTitle == true) {
        this.storeName = data.MonitorType;
      }
      if (this.widgetFieldSetting.FirstWaveTime == true) {
        let tmpInterval = data.RefreshInterval;
        if (tmpInterval && tmpInterval.indexOf(":") > 0) {
          if (
            tmpInterval.split(":")[0] != "" &&
            tmpInterval.split(":")[1] != ""
          ) {
            this.firstWaveTime.hour = +tmpInterval.split(":")[0];
            this.firstWaveTime.minute = +tmpInterval.split(":")[1];
          }
        }
      }
      if (this.widgetFieldSetting.ShipmentType) {
        let shipType: Array<string>;
        shipType = Array.isArray(data.ShipmentType)
          ? data.ShipmentType
          : JSON.parse(data.ShipmentType);
        this.selShipmentType =
          shipType && shipType.length > 0 ? shipType : ["ALL"];
      }
      if (this.widgetFieldSetting.OrderPriority) {
        let orderPriority: Array<string>;
        orderPriority = Array.isArray(data.OrderPriority)
          ? data.OrderPriority
          : JSON.parse(data.OrderPriority);
        this.selOrderPriority =
          orderPriority && orderPriority.length > 0 ? orderPriority : ["ALL"];
      }
      if (this.widgetFieldSetting.DateRange) {
        this.selDateRange = data.PickType
          ? data.PickType
          : appSettings.Last2Weeks;
      }
      if(this.widgetFieldSetting.SummaryType) {
        this.selSummaryType = data.Criteria && JSON.parse(data.Criteria).SummaryType ? JSON.parse(data.Criteria).SummaryType : this.defaultSummaryType[0].Value;
      }
      if (this.widgetFieldSetting.CountryCode) {
        let shipToCountryCode: Array<string>;
        shipToCountryCode = Array.isArray(data.ShipToCountryCode)
          ? data.ShipToCountryCode
          : JSON.parse(data.ShipToCountryCode);
        this.selCountryCode =
          shipToCountryCode && shipToCountryCode.length > 0
            ? shipToCountryCode
            : ["ALL"];
      }
      if (this.widgetFieldSetting.Carrier) {
        let carrier: Array<string>;
        carrier = Array.isArray(data.Carrier)
          ? data.Carrier
          : JSON.parse(data.Carrier);
        this.selCarrier = carrier && carrier.length > 0 ? carrier : ["ALL"];
      }
      if (this.widgetFieldSetting.HasLithirum) {
        this.lithium = data.IsLithium;
      }
      if (this.widgetFieldSetting.CommitDate) {
        let cDate = new Date(data.AppointmentDate);
        this.commitDate =
          data.AppointmentDate == null
            ? null
            : {
              year: cDate.getFullYear(),
              month: cDate.getMonth() + 1,
              day: cDate.getDate()
            };
      }
      if (this.widgetFieldSetting.WaveType) {
        let waveCode = data.WaveCode;
        let waveTitle = data.WaveTitle;
        if (waveCode && waveTitle) {
          let selWave = { value: waveCode, label: waveTitle };
          this.selWave = selWave;
        }
      }
      if (this.widgetFieldSetting.BatchWave) {
        this.checkedBatchWave = data.PickType == "Y" ? true : false;
      }
      if (this.widgetFieldSetting.PassThru) {
        this.dataPassThru = [{ m_Item1: "", m_Item2: "" }];
        if (data.PassThrus.length > 0) {
          data.PassThrus.forEach(item => {
            this.dataPassThru.push({
              m_Item1: item.m_Item1,
              m_Item2: item.m_Item2
            });
          });
        }
      }
      if (this.widgetFieldSetting.ZoneBalancing) {
        let criteria = data.Criteria ? JSON.parse(data.Criteria) : null;
        if(criteria){
          this.zbProductivityInput = criteria.ProductivityInput;
          this.zbDesiredHourlyUnits = criteria.DesiredHourlyUnits;
        }       
      }

      if (this.widgetFieldSetting.WaveOrderStatusType) {
        let criteria = data.Criteria ? JSON.parse(data.Criteria) : null;
        if(criteria){         
          this.selWaveStatusType = criteria.WaveStatusType;          
        }       
      }
      if (this.widgetFieldSetting.WaveOrderStatusActive) {
        let criteria = data.Criteria ? JSON.parse(data.Criteria) : null;
        if(criteria){
          this.selWaveStatusActive = criteria.WaveStatusActive;       
        }       
      }
      if (this.widgetFieldSetting.ReleasedWaveLookup) {
        let criteria = data.Criteria ? JSON.parse(data.Criteria) : null;
        if(criteria && criteria.ReleasedWaveLkp){    
          this.selReleasedWave = criteria.ReleasedWaveLkp;           
        }       
      }
      if (this.widgetFieldSetting.PutwallLookup) {
        let criteria = data.Criteria ? JSON.parse(data.Criteria) : null;
        if(criteria && criteria.PutwallLkp){         
          this.selPutwall = criteria.PutwallLkp;
        }       
      }
    }
  }

  save() {
    let userPref = this._commonService.getUserPreference();
    if (this.widgetFieldSetting) {
      let widgetSettings = this.widget.widgetsettings;
      if (this.widgetFieldSetting.WidgetName == true) {
        widgetSettings.WidgetName = this.widgetName;
        this.widget.widgetName = this.widgetName;
      }
      if (this.widgetFieldSetting.DaySetting == true) {
        widgetSettings.IsPast = this.checkedPast == true ? "Y" : "N";
        widgetSettings.IsFuture = this.checkedFuture == true ? "Y" : "N";
        widgetSettings.IsCurrent = this.checkedCurrent == true ? "Y" : "N";
      }
      if (this.widgetFieldSetting.PickType == true) {
        widgetSettings.PickType = this.pickType;
      }
      if (this.widgetFieldSetting.VarianceType == true) {
        widgetSettings.PickType = this.varianceType;
      }
      if (this.widgetFieldSetting.OpenTasksType == true) {
        widgetSettings.PickType = this.openTasksType;
      }
      if (this.widgetFieldSetting.ShiptoCountry == true) {
        widgetSettings.PickType = this.shiptoCountry;
      }
      if (this.widgetFieldSetting.MonitorType == true) {
        widgetSettings.MonitorType = this.monitorType;
      }
      if (this.widgetFieldSetting.StoreTitle == true) {
        widgetSettings.MonitorType = this.storeName;
      }
      if (this.widgetFieldSetting.FirstWaveTime == true) {
        let firstWave = null;
        //0hr and 0min is a valid value
        if (
          this.firstWaveTime.hour != undefined &&
          this.firstWaveTime.minute != undefined
        ) {
          firstWave = this.firstWaveTime.hour + ":" + this.firstWaveTime.minute;
        }
        widgetSettings.RefreshInterval = firstWave;
      }
      if (this.widgetFieldSetting.ShipmentType) {
        widgetSettings.ShipmentType = JSON.stringify(this.selShipmentType);
      }
      if (this.widgetFieldSetting.OrderPriority) {
        widgetSettings.OrderPriority = JSON.stringify(this.selOrderPriority);
      }
      if (this.widgetFieldSetting.DateRange) {
        widgetSettings.PickType = this.selDateRange;
        let summaryType: string = 'D';
        switch (widgetSettings.PickType) {
          case appSettings.Last1month:
            summaryType = 'W';
            break;
          case appSettings.Last2months:
            summaryType = 'W';
            break;
          case appSettings.Last3months:
            summaryType = 'M';
            break;
          case appSettings.Last6months:
            summaryType = 'M';
            break;
          case appSettings.Last13months:
            summaryType = 'M';
            break;
          case appSettings.LastWeek:
            summaryType = 'D';
            break;
          case appSettings.Last2Weeks:
            summaryType = 'D';
            break;
          case appSettings.CustomRange:
            summaryType = 'D';
            break;
        }

        widgetSettings.MonitorType = summaryType;
      }
      if(this.widgetFieldSetting.SummaryType) {
        let criteria: WidgetCriteria = new WidgetCriteria();
        criteria.SummaryType = this.selSummaryType;
        widgetSettings.MonitorType = this.selSummaryType;
        widgetSettings.Criteria = JSON.stringify(criteria);
      }
      if (this.widgetFieldSetting.CountryCode) {
        widgetSettings.ShipToCountryCode = JSON.stringify(this.selCountryCode);
      }
      if (this.widgetFieldSetting.ZoneBalancing) {
        let criteria = {ProductivityInput:this.zbProductivityInput,
                        DesiredHourlyUnits:this.zbDesiredHourlyUnits};
        widgetSettings.Criteria = JSON.stringify(criteria);  
      }
      if (this.widgetFieldSetting.WaveOrderStatusType) {
        let criteria = widgetSettings.Criteria ? JSON.parse(widgetSettings.Criteria) : null;
        if(!criteria){         
          criteria = new WidgetCriteria();       
        }
        criteria.WaveStatusType = this.selWaveStatusType; 
        widgetSettings.Criteria = JSON.stringify(criteria);                      
      }
      if (this.widgetFieldSetting.WaveOrderStatusActive) {
        let criteria = widgetSettings.Criteria ? JSON.parse(widgetSettings.Criteria) : null;
        if(!criteria){         
          criteria = new WidgetCriteria();       
        }                        
        criteria.WaveStatusActive = this.selWaveStatusActive; 
        widgetSettings.Criteria = JSON.stringify(criteria);                    
      }
      if (this.widgetFieldSetting.ReleasedWaveLookup) {
        let criteria = widgetSettings.Criteria ? JSON.parse(widgetSettings.Criteria) : null;
        if(!criteria){         
          criteria = new WidgetCriteria();       
        }                        
        criteria.ReleasedWaveLkp = this.selReleasedWave; 
        widgetSettings.Criteria = JSON.stringify(criteria);                    
      }
      if (this.widgetFieldSetting.PutwallLookup) {
        let criteria = widgetSettings.Criteria ? JSON.parse(widgetSettings.Criteria) : null;
        if(!criteria){         
          criteria = new WidgetCriteria();       
        }                        
        criteria.PutwallLkp = this.selPutwall; 
        widgetSettings.Criteria = JSON.stringify(criteria);                    
      }

      if (this.widgetFieldSetting.Carrier) {
        widgetSettings.Carrier = JSON.stringify(this.selCarrier);
      }
      if (this.widgetFieldSetting.Carrier) {
        widgetSettings.IsLithium = this.lithium;
      }
      if (this.widgetFieldSetting.CommitDate) {
        widgetSettings.AppointmentDate = this.commitDate
          ? new Date(
            this.commitDate.year,
            this.commitDate.month - 1,
            this.commitDate.day
          )
          : null;
      }
      if (this.widgetFieldSetting.WaveType) {
        widgetSettings.WaveCode = this.selWave.value;
        widgetSettings.WaveTitle = this.selWave.label;
      }
      if (this.widgetFieldSetting.BatchWave == true) {
        widgetSettings.PickType = this.checkedBatchWave == true ? "Y" : "N";
      }

      if (this.widgetFieldSetting.PassThru) {
        let passThrus: Array<any> = this._commonService.deepClone(
          this.dataPassThru
        );
        if (passThrus.length >= 1) {
          passThrus.splice(0, 1);
        }
        widgetSettings.PassThrus = passThrus;
        this.dataPassThru = [{ m_Item1: "", m_Item2: "" }];
      }

      this.widget.widgetsettings = widgetSettings;

      //save to DB
      console.time("editwidget");
      this._dashboardService
        .editWidget(
          userPref.UserId,
          userPref.FacilityId,
          userPref.CustomerId,
          widgetSettings
        )
        .subscribe(
          data => {
            console.timeEnd("editwidget");
            //Bubble up to Dashboard.
            //console.log('editwidget', data);
            this.activeModal.close(this.widget);
          },
          err => {
            console.timeEnd("editwidget");
            console.log("editwidget", err);
            this.activeModal.close(this.widget);
          }
        );
    }
  }

  addPassThru(item1: string, item2: string) {
    this.dataPassThru.push({
      m_Item1: item1,
      m_Item2: item2
    });
    //reset first element values
    this.dataPassThru[0].m_Item1 = "";
    this.dataPassThru[0].m_Item2 = "";
  }

  removePassThru(index) {
    let self = this;
    if (index > -1) {
      this.dataPassThru.splice(index, 1);
    }
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  getReleasedWaveLookup(){
    if(!this.releasedWaveArray || this.releasedWaveArray.length == 0){
      let userPref = this._commonService.getUserPreference();
    this._dashboardService.getLookUpReleasedWaves(userPref.FacilityId, userPref.CustomerId)
    .subscribe(
      data => {        
        let releasedWaves: Array<any> = []; //[{ value: "", label: "All Waves" }];
        data.forEach(item => {
          releasedWaves.push({
            value: item.Value,
            label: item.Value +  (item.Title ? ' - ' + item.Title : '')
          });
        }); 
        this.releasedWaveArray = releasedWaves;       
        this.setSelectedRelWave();                  
      },
      err => {            
        console.log("getLookUpReleasedWaves", err);
      });
    }
    else{
      this.setSelectedRelWave();
    }    
  }

  getPutwallLookup(){
    if(!this.putwallArray || this.putwallArray.length == 0){
      let userPref = this._commonService.getUserPreference();
      this._dashboardService.getLookUpPutwall(userPref.FacilityId, userPref.CustomerId)
      .subscribe(
        data => {
          let putwall: Array<any> = []; //[{ value: "", label: "All Waves" }];
          data.forEach(item => {
            putwall.push({
              value: item.Value,
              label: item.Value +  (item.Title ? ' - ' + item.Title : ''),
              activeflag: item.ActiveFlag,
            });
          }); 
          this.allPutwallArray = putwall; 
          this.setSelectedPutWall();                     
        },
        err => {
          console.log("getLookUpPutwall", err);
        });
    }    
    else{
      this.setSelectedPutWall();
    }
  }

  waveStatusTypeChange(event){
    switch (this.widget.type) {
      case appSettings.WaveOrdStatus:    
        if(event == 'INDIVIDUAL PACK WAVE') {
          this.getReleasedWaveLookup();
          this.widgetFieldSetting.ReleasedWaveLookup = true; 
        } 
        else{
          this.widgetFieldSetting.ReleasedWaveLookup = false; 
        }                
        break; 
      case appSettings.PutwallOrderStatus: 
        if(event == 'INDIVIDUAL PACK PUTWALL') {
          this.getPutwallLookup();
          this.widgetFieldSetting.PutwallLookup = true; 
        } 
        else{
          this.widgetFieldSetting.PutwallLookup = false; 
        }              
        break; 
    }
  }

  waveStatusActiveChange(event){
    if( this.widgetFieldSetting.PutwallLookup == true) {
      this.setSelectedPutWall();
    }
  }

  setSelectedRelWave(){
    if(this.widget.widgetsettings && this.releasedWaveArray && this.releasedWaveArray.length > 0){
      let criteria = this.widget.widgetsettings.Criteria ? JSON.parse(this.widget.widgetsettings.Criteria) : null;
      let itemFound = this.releasedWaveArray.find(y => {
        return criteria && criteria.ReleasedWaveLkp && y.value == criteria.ReleasedWaveLkp.value
      });
      if(itemFound){
        this.selReleasedWave = itemFound;
      }
      else{
        this.selReleasedWave = this.releasedWaveArray[0];
      }  
    }
  }

  setSelectedPutWall(){
    this.putwallArray = this.allPutwallArray.filter(x => {return !this.selWaveStatusActive || x.activeflag == this.selWaveStatusActive});      
    if(this.widget.widgetsettings && this.putwallArray && this.putwallArray.length > 0){
      let criteria = this.widget.widgetsettings.Criteria ? JSON.parse(this.widget.widgetsettings.Criteria) : null;
      let itemFound = this.putwallArray.find(y => {
        return criteria && criteria.PutwallLkp && y.value == criteria.PutwallLkp.value
      });
      if(itemFound){
        this.selPutwall = itemFound;
      }
      else{
        this.selPutwall = this.putwallArray[0];
      }           
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/shared/widgetsettings/widgetsettings.component.ts